import { useMemo } from "react";
import { TrendingUp } from "lucide-react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import Card from "../ui/Card";
import { formatUSD } from "../../lib/formatters";
import { monthKeyFromDate, today } from "../../lib/dateUtils";
import {
  aggregateAgencyMonth, aggregateAgencyAllTime, getAgencyPnlSeries,
} from "../../lib/calculations";
import { PnlCard } from "./OfferDashboard";

// Agency-wide P&L view — same shape as the per-offer view, but summed
// across every offer + every unattributed cost.
export default function AgencyPnl({ state }) {
  const mKey = monthKeyFromDate(today());

  const thisMonth = useMemo(
    () => aggregateAgencyMonth(state, mKey),
    [state, mKey]
  );
  const allTime = useMemo(
    () => aggregateAgencyAllTime(state),
    [state]
  );
  const series = useMemo(
    () => getAgencyPnlSeries(state, 6),
    [state]
  );

  return (
    <div className="space-y-4">
      <h3 className="font-display font-semibold text-xl text-brand-ink dark:text-[var(--text-primary)]">
        Agency P&L
      </h3>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <PnlCard label="This month" data={thisMonth} />
        <PnlCard label="All time" data={allTime} />
      </div>

      <Card title={<span className="inline-flex items-center gap-2"><TrendingUp size={15} /> Agency P&L (last 6 months)</span>}>
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={series} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
              <XAxis dataKey="month" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => v >= 1000 ? `${(v / 1000).toFixed(0)}k` : v} />
              <Tooltip formatter={(v) => formatUSD(v)} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="revenue" fill="#10b981" name="Revenue" />
              <Bar dataKey="cogs" fill="#f59e0b" name="COGS" />
              <Bar dataKey="opex" fill="#a855f7" name="OPEX" />
              <Bar dataKey="netProfit" fill="#3480f1" name="Net Profit" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
}